/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useContext, useState } from 'react'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { getApiTargetInfo } from 'core'
import { DatePicker, Button } from 'antd'
import { processAdhocDbReport } from 'api/pgads.js'
import { connect } from 'react-redux'

import { JcTmpErrorTable } from 'core/component/JcTmpErrorDialog'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'

const retrieveTask = apiTargetInfo => date =>
  processAdhocDbReport(apiTargetInfo)(date)

const title = 'Ad Hoc DB Process'

const AdhocDbReportProcess = ({ apiTargetInfo }) => {
  // const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
  // DatePickerContext
  // )
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState([])
  // const [fuzzyFilter, setFuzzyFilter] = useState('')
  const retrieve = _ => {
    setSpinning(true)
    retrieveTask(apiTargetInfo)({
      month: selectedDate.format('MM'),
      year: selectedDate.format('YYYY'),
    }).fork(setError, d => {
      setSpinning(false)
      setData(d)
    })
  }

  return (
    <div>
      <CriteriaRow>
        <Title>{title}</Title>
        <DatePicker.MonthPicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
            setData([])
            // setSelectedDate(d)
            // onChange()
            // retrieve({ dates: d })
          }}
        />
        <Button
          icon="database"
          loading={spinning}
          onClick={retrieve}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Process
        </Button>
        <Filler />

        {/* <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        /> */}
      </CriteriaRow>

      <FullHeightSizer heightOffset={280}>
        {({ height }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <JcTmpErrorTable errors={data} />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )

  // const screenCriteria = (s, p, u, onChange) => {
  //   return (
  //     <DatePicker.MonthPicker
  //       style={{ marginLeft: '15px' }}
  //       allowClear={false}
  //       format="MMMM-YYYY"
  //       value={selectedDate}
  //       onChange={d => {
  //         setSelectedDate(d)
  //         onChange()
  //         // retrieve({ dates: d })
  //       }}
  //     />
  //   )
  // }
  // return (
  //   <CommonScreen
  //     key="Ad Hoc DB Process"
  //     title={title}
  //     header={headers}
  //     retrieveTask={retrieveTask}
  //     // altBy={d => d.transDate}
  //     withCriteria={() => ({
  //       Date: selectedDate,
  //       month:selectedDate.format('MM'),
  //       year:selectedDate.format('YYYY')
  //     })}
  //     autoRetrieve={false}
  //     initialSortOptions={[
  //       {
  //         ident: 'errorCode',
  //         display: 'Error Code',sortOrder: 'asc'}
  //       ,{
  //         ident: 'severity',
  //         display: 'Severity', sortOrder: 'asc' },
  //     ]}
  //     withoutModify
  //     allowInsert={false}
  //     withDatePicker={false}
  //     screenCriteria={screenCriteria}
  //     retrieveLabel="Process"
  //     isAdminScreen={false}
  //   />
  // )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(AdhocDbReportProcess)
